export default __webpack_public_path__ + "static/media/mc_pulse_invalid.bb234ca2.svg";